var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 531,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m481.91 384.157-9.195-26.973-15.354 5.231L426 270.395l-34.963 11.912.105.313-11.277 48.678-16.045 69.25 9.36 20.666 33.014-11.25 12.018-4.097 13.379-4.561 10.923 32.058 34.964-11.912-10.924-32.058 15.356-5.237Zm-63.574-8.441-7.931 2.703-15.189 5.177 10.367-51.473.975-4.271 15.838 46.479-4.06 1.385Z",
    fill: "#6561AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m466.554 389.393 10.924 32.058-22.27-9.526-35.593-128.244-13.057 44.172-6.046 25.019-20.646-21.576 11.277-48.677-.105-.313L426 270.395l31.36 92.021 15.354-5.232 9.196 26.973-15.356 5.236ZM418.212 405.865l-12.018 4.097 1.766-24.767v-4.515l2.445-2.262 1.573-1.453 6.357-1.25c.001 0-.393 18.192-.123 30.15Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.338 375.715s-3.004-3.772-8.248-3.336c-5.244.436-8.17 2.403-8.346 7.865-.176 5.463 1.127 32.992-.07 43.917-1.197 10.925 6.251 12.017 6.678 3.933.428-8.084-2.737-33.429-.391-37.58 2.348-4.151.919 4.588 3.381 7.429 2.463 2.84 5.084-2.185 2.463-8.958-2.623-6.774 4.533-13.27 4.533-13.27Z",
    fill: "#9DC2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.161 334.929c-.898 0-1.563-.049-1.85-.169-.335-.141-1.357-.567-10.279-16.493l1.604-.898c3.332 5.947 8.385 14.603 9.455 15.71.971.157 6.307-.215 11.035-.69l.185 1.83c-2.977.298-7.545.71-10.15.71Z",
    fill: "#F26647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.503 342.651v.533s-.487 10.109-8.055 9.673c-.019 0-.037-.005-.056-.005-4.68-.303-10.473-2.487-14.357-4.109-2.441-1.021-4.133-1.821-4.321-1.789-.492.078 5.732 25.971 5.649 27.446a2.468 2.468 0 0 1-.124.626c-.441 1.402-1.981 3.084-2.905 3.223-.097.014-.294-.166-.574-.516-2.814-3.498-13.953-23.818-14.257-30.453-.326-7.291 3.36-11.682 8.358-12.519 3.687-.616 14.468.869 19.869 1.692 1.918.294 3.154.501 3.154.501l7.619 5.697Z",
    fill: "#0A2533"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M109.364 374.402a2.468 2.468 0 0 1-.124.626c-.441 1.402-1.981 3.084-2.905 3.223-.097.014-.294-.166-.574-.516 3.963-5.595-6.396-32.834-4.143-32.912 1.112-.037 3.572 1.853 6.418 3.922-2.441-1.021-4.133-1.821-4.321-1.789-.493.078 5.732 25.97 5.649 27.446ZM130.503 342.652v.533s-.487 10.109-8.055 9.673c1.489-1.19 1.765-3.287 1.654-5.825-.128-2.938-2.846-7.967-4.372-10.578 1.918.294 3.154.501 3.154.501l7.619 5.696Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.398 309.458c-.252.396-.418.727-.418.979l-.027-.046a30.522 30.522 0 0 0-.813-1.338c-.69-1.066-1.642-2.391-2.217-2.552-.924-.253-3.383 2.854-6.707 3.103-.221.02-.441.023-.667.015-3.659-.166-7.54-5.356-4.423-11.471 1.09 2.239 3.329 2.294 3.329 2.294s-1.366-.275-1.416-1.968c3.985.708 6.06-2.294 9.503-1.2 3.438 1.089 3.223 3.167 3.223 3.167s2.62-1.039 3.438 2.239c.657 2.622-1.793 5.206-2.805 6.778Z",
    fill: "#0A2533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.953 310.393a6.975 6.975 0 0 1-1.283 2.459c-.73.893-1.696 1.545-2.786 1.518-2.326-.055-4.639-3.177-5.668-4.764 3.324-.248 5.783-3.355 6.707-3.103.575.161 1.526 1.485 2.217 2.552.407.635.725 1.182.813 1.338Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.313 310.707s-1.747 3.991-2.404 3.117c-.354-.473-1.375-.785-2.239-.975a6.959 6.959 0 0 0 1.283-2.459l.027.046c0-.253.166-.584.418-.979 1.269.957 2.915 1.25 2.915 1.25Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.602 344.413c-2.786-.409-10.321-8.602-10.321-12.128 0-.497-.055-1.049-.147-1.65-.579-3.669-2.698-9.048-3.581-12.85-1.025-4.423.45-6.078.45-6.078 3.43-5.898 11.192 5.793 15.619 15.167l.005.005c1.489 3.158 2.474 6.091 2.565 8.055.317 6.637-1.804 9.888-4.59 9.479Z",
    fill: "#2ACAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M129.602 344.412c-2.786-.409-10.321-8.602-10.321-12.128 0-.497-.055-1.049-.147-1.65l-.018-1.572 2.73-14.308s3.77 4.483 4.372 12.51c.598 8.027 9.436 9.774 5.408-.386 1.489 3.158 2.474 6.091 2.565 8.055.318 6.637-1.803 9.888-4.589 9.479Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.758 326.718c-.073.063-.202.114-.372.161-1.292.357-5.057.303-6.625-.005a2.575 2.575 0 0 1-.542-.156c-1.034-.492 0-1.696-.326-3.825-.327-2.133-1.146-8.358 2.022-10.271 3.314-2 5.732 5.571 5.843 9.342.111 3.771.713 4.152 0 4.754Z",
    fill: "#5462AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.386 326.877s-.151 9.208-1.908 13.553v.009c-.547 1.352-1.25 2.23-2.156 2.212-3.811-.083-12.371-9.135-13.152-9.466-.777-.327-4.671.248-4.547-.327.124-.574 1.641-1.844 3.277-2.455 1.642-.615 1.352-.248 11.88 4.589-.143-.929-.083-4.947-.037-7.223.005-.345.015-.648.019-.896 1.568.307 5.332.362 6.624.004Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.504 380.625c.267 1.641-10.758 12.863-10.184 9.916.57-2.951 4.014-12.293 4.014-12.293.924-.139 2.464-1.82 2.905-3.223.902 1.563 3.04 4.239 3.265 5.6Z",
    fill: "#5462AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M122.448 346.161s-17.697-3.323-21.193-1.716c-3.496 1.606 6.396 29.573 6.396 29.573",
    stroke: "#fff",
    strokeWidth: 0.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M121.478 340.43c.336-1.849.589-7.223-.34-9.347-.625-1.435-2.951-2.667-4.396-3.314.005-.345.015-.648.019-.896 1.568.308 5.333.362 6.625.005 0-.001-.151 9.207-1.908 13.552Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.487 278.151c-.358 1.379-.956 3.154-1.885 5.53-1.324 3.407-3.324 8.05-6.271 14.523-.073 3.288-1.121 24.256-1.406 29.083-.037.589-.06.938-.069.984-.041.211-.8.616-1.627.823-.782.202-1.618.229-1.978-.249-.74-.983-5.737-20.813-5.98-25.482-.248-4.671-.492-3.605 5.24-22.201-1.393.653-10.422.409-10.422.409s1.655 22.775 1.664 22.94a.538.538 0 0 1-.046.156c-.105.313-.437 1.008-.795 1.357-.161.16-.327.252-.479.206-.087-.022-.299-.216-.606-.542-1.733-1.84-6.487-8.027-9.062-13.797-3.03-6.8-3.771-11.554-.901-16.303 2.869-4.753 17.396-5.117 17.396-5.117.92.257 3.034.51 5.126 1.007.616.143 1.232.313 1.812.506 3.182 1.057 9.245 2.399 10.551 1.646.29 1.014.354 2.2-.262 4.521Z",
    fill: "#6561AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.528 262.316c-.575.326-7.25.078-11.761-1.642.023.795.124 2.047.239 3.468.18 2.239.387 4.9.336 6.84-.028 1.384-.188 2.404-.575 2.64-.005.004-.009.009-.019.009-.693.4-2.726.206-4.96-.217a50.008 50.008 0 0 1-4.271-1.02 34.997 34.997 0 0 1-1.319-.41c-2.556-.855-5.746-1.181-6.938-1.512-.299-.083-.469-.162-.479-.253-.036-.452 1.108-1.471 1.646-2.538.064-.133.151-.331.248-.584.437-1.117 1.122-3.233 1.453-4.58.197-.795.271-1.319.097-1.228-.533.285-3.688 6.185-4.056 6.185-.128 0-.763-.364-1.517-.875-1.269-.86-2.864-2.124-2.901-2.726a.23.23 0 0 1 .074-.207c.74-.699 6.39-10.202 8.44-12.229.961-.957 2.097-1.531 3.021-1.871 1.034-.386 1.816-.474 1.816-.474 1.218-.042 2.445.12 3.641.423 4.064 1.016 7.793 3.583 9.917 4.851 2.744 1.637 4.629 1.186 5.323 1.595.701.415 3.114 6.024 2.545 6.355Z",
    fill: "#7A6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.342 270.984c-3.779.046-12.179-.29-16.666-3.885.437-1.117 1.122-3.232 1.453-4.579 0 0 8.868 2.689 14.877 1.623.18 2.239.387 4.901.336 6.841Z",
    fill: "#F69181"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M401.745 249.517c-.146 1.572-.703 3.264-2.414 3.131-2.413-.188-2.933-2.161-3.043-3.08 1.034-.386 1.816-.474 1.816-.474 1.218-.042 2.445.119 3.641.423Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.724 246.092s-.409-1.678-1.232-2.542c-.666 1.085-3.236 1.641-5.218 1.784-.938.069-1.747.046-2.156-.06-1.393-5.411 2.951-7.784 5.37-7.949 2.413-.166 4.588 1.632 3.931 4.377 2.169 2.138-.695 4.39-.695 4.39Z",
    fill: "#321212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.724 246.093c-.124.359-.317.989-.648 1.577h-.005c-.542.979-1.452 1.848-3.029 1.209-.055-.023-.11-.046-.161-.073-1.328-.603-2.018-1.775-2.367-2.699a6.279 6.279 0 0 1-.239-.772c1.981-.143 4.552-.699 5.218-1.784l.11.124c.749.892 1.121 2.418 1.121 2.418Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.517 250.272c-.243 1.517-2.744 1.435-3.016.451a24.82 24.82 0 0 0-.428-1.361c-.11-.335-.193-.552-.193-.552v-.004c.051.027.106.05.161.073 1.577.639 2.487-.229 3.029-1.209h.005c-.17.34.285.768.437 1.572.056.29.07.631.005 1.03Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.53 310.328c-.244 1.885-9.995 9.259-9.829 7.949.16-1.311 5.126-12.588 5.126-12.588.308.326.52.52.606.542.492.143 1.117-1.108 1.273-1.563 1.311 1.646 3.044 3.977 2.824 5.66ZM394.25 344.197c-2.294-4.92 0-15.352 0-15.352.736.984 3.522-.165 3.604-.574.01-.046.032-.396.069-.984 0 0 .368 4.998.805 9.232.437 4.234-2.183 12.592-4.478 7.678Z",
    fill: "#262166"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M393.51 281.163c-1.393.653-10.422.409-10.422.409s1.655 22.775 1.664 22.94a.538.538 0 0 1-.046.156c-.105.313-.437 1.008-.795 1.357-1.664-7.793-4.983-22.735-2.336-25.3 3.389-3.278 12.565-4.151 12.698-3.434.134.722-.763 3.872-.763 3.872Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.014 270.4c-.133.276-.202.506-.16.658.197.763-.851 10.321-.469 11.305.381.984.602 4.096.381 6.064-.221 1.968-4.316 3.168-4.316 1.476 0-1.696.492-5.682.657-7.213.165-1.526-1.365-12.588-.956-14.119.267-.998 1.292-2.689 1.972-3.742.363-.565.63-.952.63-.952.061.96 4.083 3.6 4.418 3.6-.001-.001-1.619 1.811-2.157 2.923Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M407.487 278.15c-1.807-.133-3.839-.924-5.255-2.345-1.646-1.646-4.391-3.172-6.846-4.326.616.143 1.232.313 1.812.506 3.182 1.057 9.245 2.399 10.551 1.646.29 1.012.354 2.198-.262 4.519ZM405.602 283.682c-1.324 3.407-3.324 8.05-6.271 14.523-.073 3.288-1.121 24.256-1.406 29.083-.037.589-.06.938-.069.984-.041.211-.8.616-1.627.823.188-7.071-.06-22.463 1.136-27.042 1.428-5.48 7.837-17.617 8.237-18.371Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M398.517 272.395a35.078 35.078 0 0 1-1.319-.409c-2.556-.855-5.746-1.182-6.938-1.513-.299-.083-.469-.161-.479-.253-.036-.451 1.108-1.471 1.646-2.538.533-1.067 2.331-6.68 1.798-6.391-.533.285-3.688 6.184-4.056 6.184-.128 0-.763-.363-1.517-.874.078-.133.165-.267.262-.409 1.964-2.896 5.187-6.5 5.733-9.613.437-2.294 1.094-.984.983 1.968-.098 2.649-.241 10.759 3.887 13.848ZM407.767 273.622c-.005.005-.009.009-.019.009-.693.4-2.726.207-4.96-.216 3.995-4.004 1.815-14.85 2.441-14.293.735.653 2.537 1.554 2.537 1.554.084 2.951 1.275 12.169.001 12.946Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M389.17 267.475s-1.618 1.812-2.156 2.924a11.256 11.256 0 0 0-.055-.671c-.124-1.172-1.949-3.72-2.837-4.901.363-.565.63-.952.63-.952.061.961 4.083 3.6 4.418 3.6ZM399.602 243.675c-.983 2.175-3.875 2.427-5.089 2.432a6.279 6.279 0 0 1-.239-.772c1.981-.143 4.552-.699 5.218-1.784l.11.124ZM400.512 249.242a1.72 1.72 0 0 1-.689.313c-1.319.299-2.248.042-2.749-.193-.11-.335-.193-.552-.193-.552v-.004c.051.027.106.05.161.073 1.577.639 2.487-.229 3.029-1.209h.005c-.17.34.285.767.436 1.572Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 5v268",
    stroke: "#0A2533",
    strokeWidth: 0.919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.189 259.393c-.009.055-.022.11-.032.161-.542 2.469-2.519 2.731-2.892 2.57-.372-.161-1.356-1.292-2.216-5.277-.019-.079-.032-.157-.051-.239 0 0-1.857-4.763-2.73-7.053-2.156-1.278-2.565-.758-2.869-2.234-.299-1.476.658-3.384 1.205-3.66.547-.271 3.002 2.023 3.333 2.869.326.845 6.744 10.242 6.252 12.863Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M422.157 259.555c-.542 2.469-2.519 2.731-2.892 2.57-.372-.161-1.356-1.292-2.216-5.277.547 1.107 1.389 2.542 2.313 3.135 1.015.647 2.156.441 2.795-.428Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.771 388.621-5.269-26.908c-3.898-19.902-11.415-34.42-22.55-43.561-11.14-9.135-24.899-12.1-41.28-8.891-16.381 3.209-27.998 11.107-34.844 23.689-6.85 12.588-8.321 28.867-4.409 48.839l5.287 27.01c3.885 19.833 11.393 34.319 22.532 43.454 4.703 3.857 9.88 6.615 15.53 8.267 7.728 2.267 16.344 2.464 25.846.606 4.924-.961 9.421-2.354 13.48-4.175 9.396-4.211 16.485-10.707 21.267-19.497 6.851-12.587 8.318-28.867 4.41-48.833Zm-32.89 36.117c-1.802 5.518-5.613 8.846-11.434 9.986-6.027 1.181-10.924-.511-14.702-5.08-2.575-3.113-4.777-7.733-6.603-13.861v-.01c-.004-.009-.004-.019-.009-.032-.846-2.841-1.609-6.009-2.29-9.498l-7.396-37.776c-1.733-9.922-1.738-17.581-.019-22.979 1.72-5.396 5.526-8.675 11.415-9.824 4.492-.883 8.367-.124 11.622 2.267h.005c1.108.818 2.146 1.82 3.112 3.016 3.802 4.703 6.744 12.372 8.822 22.996l7.158 36.554c2.016 10.642 2.122 18.719.319 24.241Z",
    fill: "#7A6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M319.525 429.786c1.518 2.336 3.535 18.215 4.57 27.166-4.06 1.821-8.557 3.214-13.48 4.175-9.502 1.857-18.118 1.66-25.846-.606.316-.713.606-1.458.854-2.221 4.823-14.735-1.204-41.321-1.48-42.517 1.825 6.128 4.027 10.748 6.603 13.861 3.778 4.569 8.675 6.261 14.702 5.08 5.82-1.141 9.632-4.469 11.434-9.986 1.803-5.521 1.696-13.599-.317-24.242l-7.158-36.554c-2.078-10.624-5.021-18.293-8.822-22.996-.966-1.195-2.004-2.197-3.112-3.016 11.627 2.28 21.07 38.278 25.005 55.643 3.93 17.368 4.261 25.4-2.953 36.213Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 5v313",
    stroke: "#0A2533",
    strokeWidth: 0.919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.344 225.937s-3.481-9.545-3.195-10.283c.287-.737 4.111-2.13 4.392-1.721.279.41 2.696 7.825 2.286 8.357-.41.533-3.483 3.647-3.483 3.647Z",
    fill: "#262166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.417 213.419s2.125.881 3.07 3.176c.944 2.294.576-5.981.576-5.981l-1.024-.942-2.622 3.747Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.311 213.418s2.663 1.987 3.114 2.11c.45.123 1.32-5.08.927-5.899-.395-.82-1.838-1.639-2.775-1.106-.938.533-1.702 4.573-1.266 4.895Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.399 214.014s-2.121-4.916-3.047-5.776c-.927-.86-2.647.246-2.771.696-.124.45 2.058.778 2.771 1.516.712.738-1.214 6.186.63 8.112 1.843 1.925 2.417-4.548 2.417-4.548Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.723 227.042s1.884-1.024 2.294-1.557c.409-.533-.328-2.54.86-4.383 1.188-1.844 3.728-1.311 4.342.901.615 2.212-.982 4.998-1.72 5.858-.738.86-5.776 4.465-5.776 4.465",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.073 231.315c-.055.327-.391.887-1.043 1.651-2.391 2.795-8.979 8.266-20.854 14.519a29.874 29.874 0 0 0-.556 2.905c-.441 3.112-.433 6.257-.285 9.084.036.727.082 1.435.133 2.115.217 2.979.511 5.439.433 6.864-.037.625-.147 1.048-.358 1.236a7.114 7.114 0 0 1-.842.635c-5.931 3.807-16.726-1.88-18.473-3.591-.138-.133-.221-.244-.238-.322-.304-1.149.873-2.377 1.53-4.345.11-.335.221-1.085.331-2.11.313-3.03.584-8.45.681-12.528.055-2.603.041-4.657-.078-5.2-.005-.009-.005-.019-.005-.019-.326-1.338-10.271-16.362-13.254-21.686-.547-.97-.859-1.618-.842-1.802.11-1.2 2.404-5.461 2.896-5.406.083.009.387.391.846 1.025 2.304 3.2 8.501 12.873 9.641 14.105 1.067 1.154 6.496 6.869 8.823 9.319.657.685 1.066 1.117 1.066 1.117a27.914 27.914 0 0 0 3.788-.335c11.176-1.724 22.159-9.549 25.033-11.724.473-.358.727-.561.727-.561s1.148 3.524.9 5.054Z",
    fill: "#4C67FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.183 243.825c-3.812.616-3.823-4.344-3.625-6.059.657.685 1.066 1.117 1.066 1.117a27.914 27.914 0 0 0 3.788-.335c.474 1.954.094 5.066-1.229 5.277Z",
    fill: "#C54527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.042 233.192c-.74.446-1.706.598-2.938.28-.947-.239-2.056-.758-3.348-1.637 0 0-1.021 1.228-1.103 3.48-2.704-2.335-3.361-4.671-1.067-5.531-.942-4.096 1.067-4.956 4.423-5.158 3.361-.207 4.138 3.236 6.146 3.154.122 1.836-.398 4.396-2.113 5.412Z",
    fill: "#262166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.042 233.191c-.037.331-.092.712-.17 1.122-.451 2.396-1.628 5.738-3.402 5.554a1.136 1.136 0 0 1-.29-.055c-1.595-.501-2.556-2.05-3.057-3.19-.331-.74-.469-1.306-.469-1.306a7.183 7.183 0 0 1 .299-1.825c.326-1.081.804-1.655.804-1.655 1.292.878 2.4 1.398 3.348 1.637 1.231.316 2.197.164 2.937-.282Z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.47 241.278c-.019.869-.138 1.549-.717 1.59-1.173.083-2.731-1.448-2.648-3.112.027-.565.037-1.167.037-1.719 0-.557-.01-1.062-.019-1.416.501 1.14 1.462 2.689 3.057 3.19.102.032.198.051.29.055-.005.484.014.971 0 1.412Z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.073 231.315c-.055.327-.391.887-1.043 1.651.031-1.954-.396-4.919-.584-6.143.473-.358.727-.561.727-.561s1.148 3.523.9 5.053ZM291.094 214.343c-1.746 1.494-2.598 4.75-2.9 6.184-.547-.97-.859-1.618-.842-1.802.11-1.2 2.404-5.461 2.896-5.406.084.008.387.389.846 1.024Z",
    fill: "#C54527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.467 261.59c-3.907.565-11.259 1.067-17.617-1.632.313-3.03.584-8.45.681-12.528 3.149 1.333 9.948 3.705 17.089 2.96-.557 3.914-.401 7.881-.153 11.2Z",
    fill: "#FCAF17"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M317.7 270.325c-6.391 4.101-18.427-2.818-18.711-3.913-.304-1.149.873-2.377 1.53-4.345.11-.335.221-1.085.331-2.11.313-3.03.584-8.45.681-12.528.055-2.603.041-4.657-.078-5.2.138.423 2.299 7.273 3.406 13.939 1.149 6.882.901 10.161 4.262 12.372 1.967 1.292 5.558 1.973 8.579 1.785Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.305 289.243c0 2.841-10.271 18.583-12.398 21.814-.244.373-.382.58-.382.58s-1.324-.152-2.414-.52c-.758-.263-1.406-.621-1.406-1.117 0-.102.019-.258.051-.465.363-2.193 2.62-10.128 5.517-20.619-1.526-1.857-12.233-8.96-12.233-8.96s-.005.009-.01.027c-.464 1.071-15.327 35.441-17.015 38.646-.06.115-.102.188-.129.221-.763.984-3.931 1.09-4.151-.984v-.009c-.91-8.688 6.583-34.895 10.073-46.484a425.064 425.064 0 0 1 1.42-4.639c1.747 1.71 12.542 7.397 18.473 3.591.294-.189.575-.4.842-.635.211-.188.321-.611.358-1.236.11.119.226.248.34.386 4.136 4.73 13.064 17.667 13.064 20.403Z",
    fill: "#9DC2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.062 323.438c-.409 2.046-11.227 8.11-10.242 4.441.8-2.975 3.806-8.165 4.914-10.022v.009c.221 2.074 3.389 1.969 4.151.984.027-.032.069-.105.129-.221.552 1.582 1.315 3.485 1.048 4.809ZM323.46 321.635c-.823.41-11.471-3.687-11.227-5.08.248-1.393 3.521-7.02 3.521-7.02a3.48 3.48 0 0 0-.051.465c0 1.199 3.82 1.637 3.82 1.637s.138-.207.382-.58c.475 4.253 4.323 10.193 3.555 10.578Z",
    fill: "#262166"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M307.646 278.783s-11.799 23.171-16.224 39.074M310.431 278.783s13.109 8.603 13.602 9.996c.491 1.393-6.801 20.757-6.801 20.757",
    stroke: "#010101",
    strokeWidth: 0.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M319.24 268.838c-1.443 5.765-9.802 4.198-14.077 3.09-2.487-.644-5.338-.667-7.355-.557a425.064 425.064 0 0 1 1.42-4.639c1.747 1.71 12.542 7.397 18.473 3.591.294-.189.575-.4.842-.635.211-.188.321-.611.358-1.236.109.12.224.249.339.386ZM317.111 311.119c-.758-.263-1.406-.621-1.406-1.117 0-.102.019-.258.051-.465.363-2.193 2.62-10.128 5.517-20.619-1.526-1.857-12.233-8.96-12.233-8.96s.873-2.947 1.857-3.167c.983-.216 12.344 9.558 13.599 11.581 1.107 1.777-6.63 16.287-7.385 22.747ZM317.042 233.192c-.037.331-.092.712-.17 1.122-2.864 1.458-5.674-1.825-6.009-1.784-.193.023-.589.52-.91.961.326-1.081.804-1.655.804-1.655 1.292.878 2.4 1.398 3.348 1.637 1.231.317 2.197.165 2.937-.281ZM313.47 241.278c-1.89-.46-2.934-2.354-3.328-3.241 0-.557-.01-1.062-.019-1.416.501 1.14 1.462 2.689 3.057 3.19.102.032.198.051.29.055-.005.484.014.971 0 1.412ZM318.62 250.389c-.441 3.112-.433 6.257-.285 9.084-.745-3.14-1.397-6.515-.635-8.468 1.314-3.365 1.457-3.521 1.476-3.521a29.23 29.23 0 0 0-.556 2.905Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.634 281.742-35.372-6.078-.055.317-78.115 87.948-1.613 21.985 11.204 1.926 19.392 3.333 26.03 4.474 2.474.423-1.862 10.845-.864 5.017-2.846 16.573 23.023 3.958 12.35 2.12 5.571-32.435 15.539 2.666 4.689-27.295-15.539-2.666 15.994-93.111Zm-44.157 45.068-7.214 41.965-8.629-1.485-18.873-3.24 10.45-12.473 2.391-2.855 19.925-23.782 2.818-3.19-.868 5.06Z",
    fill: "#6561AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m168.105 395.647-26.03-4.474c3.066-10.128 6.892-24.086 5.687-27.124l18.873 3.24c1.209 2.015 2.165 4.786 2.423 8.589.459 6.731-.544 13.604-.953 19.769Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.888 364.245s2.838-3.938 9.229-2.708c6.391 1.23 6.883 9.096 4.097 17.781-2.786 8.685-3.441 39-2.131 48.832 1.312 9.832.492 14.421-2.621 14.748-3.113.328-4.589-11.799-2.786-20.319 1.803-8.521 1.639-16.387-1.311-15.076-2.95 1.312-.492 4.589-1.967 7.538s-5.899 1.147-5.735-4.425c.164-5.572 9.073-41.781 3.225-46.371Z",
    fill: "#9DC2E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m210.64 374.853 15.539 2.666-4.689 27.295-15.539-2.666-5.572 32.435-12.349-2.121 21.705-135.429 16.899-15.291-15.994 93.111Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 5v277",
    stroke: "#0A2533",
    strokeWidth: 0.919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.55 248.622a6.391 6.391 0 1 0 0-12.782 6.391 6.391 0 0 0 0 12.782Z",
    fill: "#F47920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.91 329.839a6.392 6.392 0 1 0-.002-12.784 6.392 6.392 0 0 0 .002 12.784Z",
    fill: "#6561AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.762 283.177a6.392 6.392 0 1 0-.002-12.784 6.392 6.392 0 0 0 .002 12.784Z",
    fill: "#9DC2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.16 478.62a6.391 6.391 0 1 0 0-12.782 6.391 6.391 0 0 0 0 12.782Z",
    fill: "#F26647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.376 263.934a2.465 2.465 0 1 0-.001-4.931 2.465 2.465 0 0 0 .001 4.931Z",
    fill: "#F47920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.085 302.317a2.465 2.465 0 1 0-.001-4.931 2.465 2.465 0 0 0 .001 4.931Z",
    fill: "#9DC2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.345 268.942a2.465 2.465 0 1 0-.001-4.931 2.465 2.465 0 0 0 .001 4.931Z",
    fill: "#6561AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.823 131.386s-9.851-9.832-28.522-5.899c-18.672 3.933-31.795 33.429-45.389 39.983-13.595 6.555-40.396 25.91-42.399 42.451 26.183-21.803 36.015-12.299 53.057-14.921s18.353-22.614 42.934-21.958c24.58.655 50.799 31.197 75.379 14.124 24.58-17.073 53.421-37.393 30.151-54.107s-70.463 8.848-85.211.327Z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.974 197.839s-2.564 13.679 11.213 26.881c13.776 13.202 45.536 7.406 58.615 14.936s44.177 18.75 58.967 11.075c-32.771-9.327-30.467-22.806-42.243-35.402-11.775-12.595-29.024-2.404-42.344-23.072-13.32-20.669-2.885-59.544-30.845-70.215-27.961-10.671-61.006-23.03-61.687 5.612-.681 28.642 47.044 53.2 48.324 70.185Z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.84 276.261s-39.983 43.868-48.505 95.302c-8.521 51.435-49.507 48.157-63.426 72.409-13.92 24.252-47.092 26.219-62.296 36.051s-49.843-7.21-55.793 0c-5.949 7.21 31.07 18.354 79.091 19.009 48.021.655 57.196-36.706 99.802-41.95 42.606-5.244 85.211-23.597 100.287-93.078 15.077-69.479-10.487-106.662-49.16-87.743Z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.78 293.928s39.983 43.869 48.505 95.302c8.52 51.434 49.507 48.156 63.426 72.409 13.919 24.252 47.092 26.219 62.296 36.051s49.843-7.21 55.793 0c5.949 7.21-31.07 18.353-79.091 19.009-48.021.655-57.196-36.707-99.802-41.95-42.605-5.244-85.212-23.597-100.287-93.077-15.077-69.48 10.487-106.664 49.16-87.744Z",
    fill: "url(#r)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 108.641,
    y1: 314.175,
    x2: 109.542,
    y2: 305.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 119.998,
    y1: 311.323,
    x2: 112.132,
    y2: 311.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 109.701,
    y1: 343.428,
    x2: 116.911,
    y2: 317.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 397.377,
    y1: 248.502,
    x2: 397.705,
    y2: 241.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 398.833,
    y1: 251.691,
    x2: 398.587,
    y2: 246.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 382.396,
    y1: 291.892,
    x2: 388.295,
    y2: 253.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 415.4,
    y1: 245.64,
    x2: 419.988,
    y2: 269.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 285.266,
    y1: 209.945,
    x2: 288.135,
    y2: 216.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 280.916,
    y1: 209.794,
    x2: 288.044,
    y2: 212.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 285.007,
    y1: 207.5,
    x2: 289.596,
    y2: 217.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 350.341,
    y1: 217.15,
    x2: 337.315,
    y2: 232.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 313.907,
    y1: 240.753,
    x2: 312.514,
    y2: 224.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 311.524,
    y1: 240.879,
    x2: 312.18,
    y2: 236.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 552.579,
    y1: 151.209,
    x2: 331.685,
    y2: 202.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 114.18,
    y1: 157.131,
    x2: 280.968,
    y2: 310.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 575.555,
    y1: 374.907,
    x2: 258.48,
    y2: 448.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 35.065,
    y1: 392.571,
    x2: 352.14,
    y2: 465.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC2E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h592v531H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.e3cbe2babbf1a3950f110ecce5499228.svg";
export { ForwardRef as ReactComponent };